<template>
    <div :class="`JobIndex__item JobIndex__item--form-` + job.primarni_forma">
        <div class="d-flex justify-content-between">

            <div>
                <h2 class="JobIndex__item__nazev">
                    <a :href="job.links.self">{{ job.nazev }}</a>
                </h2>
                <div class="JobIndex__item__firma">
                    <a :href="job.links.firma">{{ job.firma_nazev }}</a>
                </div>
            </div>

            <div class="text-right">
                <portal-indicator v-if="job.tags" :tags="job.tags"></portal-indicator>
                <span class="badge JobIndex__item__aktualnost" v-if="job.aktualnost">{{ job.aktualnost }}</span>
                <span class="badge badge-danger" v-if="'views_all' in job">
                    {{ job.views_all }}
                    <span class="text-white-50">/</span>
                    {{ job.views_by_authorised_user }}
                    <span class="text-white-50">/</span>
                    {{ job.responses_count }}
                </span>
                <span class="JobIndex__item__date">{{ job.platnost_od_cs }}</span>
                <job-favourite
                    v-if="auth && auth.role === 'student'"
                    :endpoint="url(`/api/jobs/${job.id}/toggle-favourite/${auth.id}`)"
                    :state="job.favourited_by_auth"
                ></job-favourite>
            </div>

        </div>
        <div class="JobIndex__item__charakteristika">
            {{ job.charakteristika }}
        </div>
    </div>
</template>

<script>
import PortalIndicator from '../admin/PortalIndicator';

export default {

    components: {
        'portal-indicator': PortalIndicator
    },

    props: [
        'data'
    ],

    data() {
        return {
            job: this.data,
            auth: window.App.auth
        }
    }
}
</script>
